export const VOCAB_CONTENT_NODE_ID =
	"TGVhcm5PcHBvcnR1bml0eVYyOk5vZGU6c3RhbmRhbG9uZS12b2NhYi1jb250ZW50";

export const USER_IN_ACCOUNT_GROUP_OWNER_ID = "VXNlckluQWNjb3VudEdyb3VwOm93bmVy";
export const USER_IN_ACCOUNT_GROUP_USER_ID = "VXNlckluQWNjb3VudEdyb3VwOnVzZXI=";
